<script setup>
import CommonGrid from "../../../../frontend/src/components/CommonGrid.vue";
import useGrid from "@/composables/useGrid";
import {nextTick, onMounted, ref, watch} from "vue";
import marketSubSectorsService from "@/services/market-sub-sectors.service";
import MarketSubSectorEdit from "@/components/marketSubSectors/MarketSubSectorEdit.vue";
import FocusAreasModal from "@/views/market/FocusAreasModal.vue";
import PartnershipsModal from "@/components/partnerships/PartnershipsModal.vue";
import {useRoute} from "vue2-helpers/vue-router";

const route = useRoute();
const {items, gridParams, gridMethods} = useGrid(getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
        filter: 'text',
    },
    {
        label: 'Name',
        name: 'name',
        filter: 'text',
    },
    {
        label: 'Sector',
        name: 'sector_name',
    },
    {
        label: 'Partnerships',
        name: 'partnerships_count',
        component: 'Link',
        sortable: true,
    },
    {
        label: 'Focus Areas',
        name: 'focus_areas_count',
        component: 'Link'
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const edit = ref(null);
const focusAreasModal = ref(null);
const partnershipsModal = ref(null);
const mountCounter = ref(0);
const notAssignedToSector = ref(false);

watch(notAssignedToSector, () => {
    gridMethods.resetList();
});

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function getList(pageParams) {
    if (route.query.sector_id) {
        pageParams.filters.sector_id = route.query.sector_id;
    }

    if (notAssignedToSector.value) {
        pageParams.filters.not_assigned_to_sector = true;
    }

    return marketSubSectorsService.getIndexList(pageParams);
}

async function remove(id) {
    if (confirm("Delete Sub-Sector?")) {
        await marketSubSectorsService.delete(id);
        gridMethods.updateList();
    }
}

function gridAction(params) {
    if (params.action === 'edit') {
        edit.value.open(params.rowId);
    } else if (params.action === 'delete') {
        remove(params.rowId);
    } else if (params.action === 'showFocusAreas') {
        focusAreasModal.value.open(params.rowId);
    } else if (params.action === 'showPartnerships') {
        showPartnerships(params.rowId);
    }
}

async function showPartnerships(subsectorId) {
    mountCounter.value += 1;
    await nextTick();
    partnershipsModal.value.open(subsectorId);
}
</script>

<template>
    <div>
        <div class="topbar pl-sm-5">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="buttons-container">
                        <button class="button w-100 w-sm-auto" @click="edit.open()">Add Sub-Sector</button>

                        <div class="input-checkbox pt-1">
                            <input id="filterInTrackers" class="ml-2" type="checkbox" v-model="notAssignedToSector">
                            <label for="filterInTrackers">Not assigned to sector</label>
                        </div>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <CommonGrid
                    :columns="columns"
                    :items="items"
                    :gridParams="gridParams"
                    :gridMethods="gridMethods"
                    :gridAction="gridAction"
                />
            </div>
        </div>

        <MarketSubSectorEdit
            ref="edit"
            @saved="gridMethods.updateList"
        />

        <FocusAreasModal
            ref="focusAreasModal"
        />

        <PartnershipsModal
            :key="`partnerships-` + mountCounter"
            ref="partnershipsModal"
        />
    </div>
</template>

<style scoped>

</style>
